/* RESPONSIBLE TEAM: team-standalone */

import type { KnowledgeHubModalData } from '../definitions';
import type ZendeskPlatform from '../../zendesk';

export default class ZendeskKnowledgeHubModalData implements KnowledgeHubModalData {
  private platform: ZendeskPlatform;

  constructor(platform: ZendeskPlatform) {
    this.platform = platform;
  }

  get integrationWarning() {
    let hasConnection = this.platform.zendeskConfig?.isConnected;
    let hasFinUser = !!this.platform.zendeskConfig?.ticketsIntegration?.finZendeskUserId;

    if (!hasConnection) {
      return 'zendesk-tickets-integration' as const;
    }
    if (!hasFinUser) {
      return 'zendesk-fin-user' as const;
    }
    return null;
  }

  get settingsBlockedReason(): string {
    if (this.platform.zendeskConfig?.isConnected === false) {
      return this.platform.intl.t(
        'knowledge-hub.conversational.conversation-extraction-settings.standalone.settings-blocked-reason.no-integration.zendesk',
      );
    }

    if (!this.platform.zendeskConfig?.ticketsIntegration?.finZendeskUserId) {
      return this.platform.intl.t(
        'knowledge-hub.conversational.conversation-extraction-settings.standalone.settings-blocked-reason.no-fin-id',
      );
    }

    return '';
  }
}
